// extracted by mini-css-extract-plugin
export default {"root":"multiSelect_root__LIH64","option":"multiSelect_option__jVALX","selected":"multiSelect_selected__YHlMa","text":"multiSelect_text__uTHDl"};